import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailarrayComponent } from '@app/shared/form-control/email-form-control/emailarray.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PhonearrayComponent } from '@shared/form-control/phone-form-control/phonearray.component';
import { WebsitearrayComponent } from '@shared/form-control/website-form-control/websitearray.component';
import { AddressarrayComponent } from '@shared/form-control/address-form-control/addressarray.component';
import { DbaarrayComponent } from '@shared/form-control/dba-form-control/dbaarray.component';
import { RecordmanagerarrayComponent} from '@shared/form-control/record-manager-form-control/recordmanagerarray.component';
import { ReferredarrayComponent } from '@shared/form-control/referred-form-control/referredarray.component';
import { MapPopupModule } from '@shared/map-popup/map.popup.module';
import { SocialPopupModule } from '@shared/modal-popup/social.popup.module';
import { PhoneMaskDirective } from './phone-form-control/phone-mask.directive';
import { CamelCaseDirective } from './dba-form-control/camel-case.directive';
import { ImageModalComponent } from './image-modal/image-modal.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MapPopupModule,
    SocialPopupModule
  ],
  declarations: [
    EmailarrayComponent,
    PhonearrayComponent,
    WebsitearrayComponent,
    AddressarrayComponent,
    DbaarrayComponent,
    RecordmanagerarrayComponent,
    ReferredarrayComponent,
    ReferredarrayComponent,
    PhoneMaskDirective,
    CamelCaseDirective,
    ImageModalComponent
  ],
  exports: [
    EmailarrayComponent,
    PhonearrayComponent,
    WebsitearrayComponent,
    AddressarrayComponent,
    DbaarrayComponent,
    RecordmanagerarrayComponent,
    ReferredarrayComponent,
    CamelCaseDirective,
    ImageModalComponent,
    PhoneMaskDirective,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
]
})

export class FormControlModule { }



// WEBPACK FOOTER //
// ./src/app/shared/form-control/form-control.module.ts